import { render, staticRenderFns } from "./CardBodyStamp.vue?vue&type=template&id=db89584c&scoped=true"
import script from "./CardBodyStamp.vue?vue&type=script&lang=js"
export * from "./CardBodyStamp.vue?vue&type=script&lang=js"
import style0 from "./CardBodyStamp.vue?vue&type=style&index=0&id=db89584c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db89584c",
  null
  
)

export default component.exports